<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            Masalar
        </div>
        <el-row :gutter="10">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <div>
                        <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                        text-color="gray">
                            <el-radio-button label="1">
                                <i class="mdi mdi-bullhorn mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='1'">Aktif Masalar</label>
                                </transition>
                            </el-radio-button>
                            <el-radio-button label="0">
                                <i class="mdi mdi-bullhorn mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='0'">Pasif Masalar</label>
                                </transition>
                            </el-radio-button>
                        </el-radio-group>
                    </div>
                    <el-table
                            border
                            stripe
                            :data="masaList"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="masaNo"
                                label="Masa No"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='1'"
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.sayfa.liste.yayindanKaldir")' :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='0' "
                                            @click="masaDurumGuncelle(scope.row,scope.$index,masaList,1)"
                                            type="text"
                                            icon="mdi mdi-play mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <el-form status-icon :model="masaForm" :rules="rulesKategori" ref="masaForm"
                             class="demo-ruleForm">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item
                                            label='Masa No'
                                            prop="baslik">:
                                        <!--<div v-if="linkVisible" style="float: right; display: flex">-->
                                        <!--<div v-if="!VisibleA">-->
                                        <!--<el-link target="_blank" :underline="false"-->
                                        <!--:href="this.path">-->
                                        <!--{{this.path}}{{this.masaForm.link}}-->
                                        <!--</el-link>-->
                                        <!--</div>-->
                                        <!--<el-button v-if="duzenleBtnVisible"-->
                                        <!--style="margin-left: 10px; margin-bottom: 5px"-->
                                        <!--v-on:click="VisibleA = true; duzenleBtnVisible=false"-->
                                        <!--size="mini">Düzenle-->
                                        <!--</el-button>-->
                                        <!--<span v-if="VisibleA">{{this.path}}</span>-->
                                        <!--<el-input v-if="VisibleA" v-model="masaForm.link"-->
                                        <!--v-on:change="$store.commit('changeTabsClose', false);linkChange = false"-->
                                        <!--v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"-->
                                        <!--style="width: 50%" size="mini"></el-input>-->
                                        <!--</div>-->
                                        <el-input
                                                v-model="masaForm.baslik"
                                                :placeholder='$t("src.views.apps.haberler.tanimlama.baslikPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Masa Kategori' prop="kategori">:
                                        <el-select
                                                v-model="masaForm.kategori"
                                                :placeholder='$t("src.views.apps.haberler.tanimlama.kategoriPlace")'
                                                style="width: 100%">
                                            <el-option v-for="item in kategoriListe"
                                                       :key="item.mkategoriId"
                                                       :label="item.baslik"
                                                       :value="item.mkategoriId"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small" v-on:click="masaTanimlama('masaForm')"
                                           type="primary">
                                    Masa Ekle
                                </el-button>
                                <el-button v-else size="small" v-on:click="guncelleme('masaForm')" type="primary">
                                  Masa Güncelle
                                </el-button>
                                <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('masaForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["masaNo"]}}" masasının durumunu değiştirmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="masaDurumGuncelle(selection,selectionIndex,masaList,0), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import masaService from '../../../WSProvider/MasaService'
    import seoService from '../../../WSProvider/SeoService'
    import notification from '../../../notification'

    export default {
        name: "Masalar",
        mounted() {
            this.getMasaList();
            this.getKategoriList();
        },
        data() {
            return {
                selectIcon: '1',
                radio: '1',
                masaList: [],
                kategoriListe: [],
                path: masaService.path,
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                masaForm: {
                    baslik: '',
                    kategori: '',
                },
                rulesKategori: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Başlık Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            linkTespitLink() {
                let self = this;
                if (this.masaForm.link) {
                    seoService.linkKontrol(self.masaForm.link.replace("'", "").substring(0, 55)).then((response) => {
                        if (response.status === 200) {
                            self.masaForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.masaForm.baslik && this.linkChange) {
                    seoService.linkKontrol(this.masaForm.baslik.replace("'", "").substring(0, 55)).then((response) => {
                        if (self.masaForm.baslik) {
                            if (response.status === 200) {
                                self.linkVisible = true;
                                self.masaForm.link = response.data;
                            }
                        } else if (!self.masaForm.baslik) {
                            self.linkVisible = false;
                            self.masaForm.link = '';
                        }
                    })
                }
            },
            handleChange(event) {
                this.selectIcon = event;
                this.getMasaList();
            },
            getMasaList() {
                let self = this;
                masaService.masaList(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.masaList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getKategoriList() {
                let self = this;
                masaService.kategoriList(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.kategoriListe = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                this.masaForm.baslik = scope.masaNo;
                this.masaForm.kategori = scope.mkategoriId;
                this.updateKodu = scope.masaId ;
                this.btnVisible = false;
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },
            masaTanimlama(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        masaService.masaTanimlama(this.masaForm.kategori,this.masaForm.baslik).then((response) => {
                            if (response.status === 200) {
                                this.masaList.push(response.data);
                                notification.Status('success', this, 'Masa başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                                this.linkVisible = false;
                                this.VisibleA = false;
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            guncelleme(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        masaService.masaGuncelle(this.updateKodu, this.masaForm.baslik,this.masaForm.kategori).then((response) => {
                            if (response.status === 200) {
                                this.masaList.splice(this.selectionIndex, 1);
                                this.masaList.splice(this.selectionIndex, 0, {
                                    masaNo: response.data.masaNo,
                                    mkategoriId: response.data.mkategoriId,
                                    masaId : response.data.masaId
                                });
                                notification.Status('success', this, 'Masa başarıyla güncellendi...');
                                this.$refs[formName].resetFields();
                                this.btnVisible = true;
                                this.linkVisible = false;
                                this.VisibleA = false;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir masa zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            masaDurumGuncelle(selection, index, list, durum) {
                masaService.masaDurumGuncelle(selection.masaId , durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Masa durumu değiştirildi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

</script>


<style scoped>

</style>